import React from 'react';
import styles from "./myAccountUser.scss";
import { getLocalizedStrings } from "../../centralizedLocalizedString";
import { getLocalizedStringstwo } from "../../centralizedLocalizedStringtwo";
import EmergencyAlertContainer from "../EmergencyAlerts/emergencyAlertContainer";
import OutageAlertContainer from "../OutageAlerts/outageAlertContainer";
import PaperlessBillingContainer from "../PB/PaperlessBillingContainer";
import BudgetAssistantContainer from "../BudgetAssistance/budgetAssistanceContainer";
import CriticalPeakPricing from "./cpp/CriticalPeakPricing";

const myAccountUser = (props) => {
    let strings = getLocalizedStringstwo("MyAccountUser");
    let paprString = getLocalizedStrings("PaperlessBilling");
    let cppString = getLocalizedStrings("CppAlerts");
    let accountDetails = props.accountDetails;
    let preferenceDetails = props.preferenceDetails;
    let cpcData = props.cpcData;
    let customerData = props.customerData;
    let prefDetails = props.prefDetails;
    let ebillpaprCount = props.ebillpaprCount;
    let isActiveAccount = props.cpcData.contractAccountResults[0].contractAccountStatus === app.appUtil.getAppConstants().MY_ACCOUNT_SERVICES.ACTIVE_ENROLLMENT_STATUS;
    let isPendingAccount = props.cpcData.contractAccountResults[0].contractAccountStatus === app.appUtil.getAppConstants().MY_ACCOUNT_SERVICES.STATUS_PENDING;
    return (

        <div>
            <div className={styles.cardCointainer}>
                <div>
                    <PaperlessBillingContainer
                        AlertName1={paprString.AlertName1}
                        AlertName2={paprString.AlertName2}
                        AlertExp={paprString.AlertExp}
                        accountData={accountDetails}
                        preferenceData={preferenceDetails[0].papr}
                        cpcData={cpcData}
                        customerData={customerData}
                        refreshPage={props.refreshPage}
                        singlePaprRecord={props.singlePaprRecord} desinglePaprRecord={props.desinglePaprRecord}
                        ebillpaprRecord={props.ebillpaprRecord} ebillpaprSold={props.ebillpaprSold} ebillpaprAuth={props.ebillpaprAuth}
                        onPbToggleOnOffClick={props.onPbToggleOnOffClick}
                        dropDownData={props.dropDownData} ebillpaprCount={ebillpaprCount}
                        staticContent={props.staticContent.pb}
                    />
                </div>

                
                    <div>
                    {
                        (isActiveAccount || isPendingAccount) ? <div>
                            <div className={styles.conHeading}>{strings.OutageAlertsLabel}   </div>
                            <div>
                                <EmergencyAlertContainer
                                    accountData={accountDetails} dropDownData={props.dropDownData}
                                    preferenceData={preferenceDetails[0].emrg} updateDropDownData={props.updateDropDownData}
                                    selectedAccount={!_.isEmpty(props.cpcData.contractAccountResults) ? !_.isEmpty(props.cpcData.contractAccountResults[0].contractResults) ? props.cpcData.contractAccountResults[0].contractResults[0] : {} : {}}
                                    formattedDataForEmrg={props.formattedDataForEmrg}
                                    refreshPage={props.refreshPage} removePreference={props.removePreference}
                                    mainBpNumber={props.cpcData.bpNumber} staticContent={props.staticContent.ea}
                                />
                            </div>
                            <br />
                            <div>
                                <OutageAlertContainer
                                    accountData={accountDetails} dropDownData={props.dropDownData}
                                    preferenceData={preferenceDetails[0].outg} updateDropDownData={props.updateDropDownData}
                                    selectedAccount={!_.isEmpty(props.cpcData.contractAccountResults) ? !_.isEmpty(props.cpcData.contractAccountResults[0].contractResults) ? props.cpcData.contractAccountResults[0].contractResults[0] : {} : {}}
                                    formattedDataForOutg={props.formattedDataForOutg}
                                    refreshPage={props.refreshPage} removePreference={props.removePreference}
                                    mainBpNumber={props.cpcData.bpNumber} staticContent={props.staticContent.rm}
                                />
                            </div>
                        </div> : null
                    }
                     
                    {
                        isActiveAccount ? <div>
                            <div className={styles.conHeading}>{strings.OtherAlertsLabel}</div>
                            <div>
                                <BudgetAssistantContainer
                                    accountData={accountDetails} dropDownData={props.dropDownData}
                                    preferenceData={preferenceDetails[0].buda} updateDropDownData={props.updateDropDownData}
                                    selectedAccount={!_.isEmpty(props.cpcData.contractAccountResults) ? !_.isEmpty(props.cpcData.contractAccountResults[0].contractResults) ? props.cpcData.contractAccountResults[0].contractResults[0] : {} : {}}
                                    baEnrollmentDetailsVO={props.cpcData.baEnrollmentDetailsVO}
                                    formattedDataForBuda={props.formattedDataForBuda}
                                    refreshPage={props.refreshPage} removePreference={props.removePreference}
                                    mainBpNumber={props.cpcData.bpNumber} staticContent={props.staticContent.ba}
                                    billingRateType={props.billingRateType}
                                />
                            </div>
                            <br />
                            <div>
                                <CriticalPeakPricing
                                    AlertName1={cppString.AlertName1}
                                    AlertName2={cppString.AlertName2}
                                    AlertExp={cppString.AlertExp}
                                    accountData={prefDetails}
                                    preferenceData={preferenceDetails[0].cpp}
                                    isMultiAcc={0} updateDropDownData={props.updateDropDownData}
                                    cpcData={cpcData} dropDownData={props.dropDownData}
                                    refreshPage={props.refreshPage} removePreference={props.removePreference}
                                    refreshPref={props.refreshPref}
                                    mainBpNumber={props.cpcData.bpNumber} staticContent={props.staticContent.cpp}
                                />
                            </div>
                        </div> : null
                    }
                     
                    </div>
            </div>
        </div>
    );
};
export default myAccountUser;
